import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { AbTestVariantsSchema } from 'features/ab-tests/types/abTestVariantsSchema'
import { fromDTO } from './api/mapper'
import { GET_AB_TEST_VARIANTS_SCHEMA } from './api/query'

import type { Props, UseGetAbTestVariantsSchema } from './types'

export const useGetAbTestVariantsSchema = ({ domainId }: Props): UseGetAbTestVariantsSchema => {
  const [schema, setSchema] = useState<AbTestVariantsSchema>()

  const { loading } = useQuery(GET_AB_TEST_VARIANTS_SCHEMA, {
    onCompleted: ({ abTestVariantsSchema }): void => {
      if (abTestVariantsSchema) {
        setSchema(fromDTO(abTestVariantsSchema))
      }
    },
    skip: !domainId,
    variables: { domainId },
  })

  return {
    loading,
    schema,
  }
}
